function CookieUtil () {
  this.defaultLiftTime = 12 * 60 * 60 * 1000
}

CookieUtil.prototype.setCookieUtil = function setCookieUtil (name, value, expires, domain) {
  let cookieText = ''
  cookieText += encodeURIComponent(name) + '=' + encodeURIComponent(value)
  if (expires instanceof Date) {
    cookieText += '; expires=' + expires.toGMTString()
  } else {
    cookieText += '; expires=' + new Date(new Date().getTime() + this.defaultLiftTime).toGMTString()
  }
  if (domain) {
    cookieText += '; domain=' + domain
  }
  document.cookie = cookieText
}
CookieUtil.prototype.delCookieUtil = function (name, domain) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = this.getCookieUtil(name)
  if (cval != null) {
    if (!domain) {
      document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
    } else {
      document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() + '; domain=' + domain
    }
  }
}
CookieUtil.prototype.getCookieUtil = function (name) {
  // let cookieName = encodeURIComponent(name) + '='
  // let cookieStart = document.cookie.indexOf(cookieName)
  // let cookieValue = ''
  // if (cookieStart !== -1) {
  //   let cookieEnd = document.cookie.indexOf(';', cookieStart)
  //   if (cookieEnd === -1) {
  //     cookieEnd = document.cookie.length
  //   }
  //   cookieValue = decodeURIComponent(document.cookie.substring(cookieStart + cookieName.length, cookieEnd))
  // }
  // return cookieValue
  const cookieName = encodeURIComponent(name)
  const cookiesList = document.cookie.split(';')
  for (const item of cookiesList) {
    const [cookieKey, cookieValue] = item.split('=')
    if (cookieKey.trim() === cookieName) {
      return decodeURIComponent(cookieValue)
    }
  }
  return ''
}
CookieUtil.prototype.setOnlyCookie = function (name, value, domain) {
  let cookieText = ''
  cookieText += encodeURIComponent(name) + '=' + encodeURIComponent(value) + ';domain=' + domain
  document.cookie = cookieText
}

let cookie = new CookieUtil()

export default cookie
